import { Field, FieldProps } from 'formik';
import { FormComponent } from '@synergy/abstract';
import { PoolRow } from '@synergy/components-next';
import { PoolTextArea, PoolTypography } from '@synergy/components';
import { PropsWithChildren, ReactNode } from 'react';
import { Theme } from '@mui/material';
import { WithStyles, createStyles, withStyles } from '@mui/styles';

import { Offer } from '../../../../../common/models/offer';

const styles = (theme: Theme) =>
    createStyles({
        container: {
            marginBottom: theme.spacing(2),
        },
        important: {
            display: 'flex',
            alignItems: 'center',
            marginBottom: theme.spacing(),

            '& > span': {
                marginRight: theme.spacing(),
            },
        },
    });

interface OfferFooterConditionsItemProps extends PropsWithChildren, WithStyles<typeof styles> {
    icon?: ReactNode;
    titleId: string;
    fieldName: string;
    readonly?: boolean;
}

class OfferFooterConditionsItemBase extends FormComponent<Offer, OfferFooterConditionsItemProps> {
    public render() {
        const { classes, icon, titleId, fieldName, readonly, children } = this.props;

        return (
            <div className={classes.container}>
                <PoolRow sx={{ mb: 1 }}>
                    {icon} <PoolTypography id={titleId} />
                </PoolRow>
                {children || (
                    <Field name={fieldName}>
                        {({ field, form }: FieldProps<Offer>) => {
                            return (
                                <PoolTextArea
                                    id={fieldName}
                                    fullWidth={true}
                                    readOnly={readonly}
                                    error={this.hasError(form, field.name)}
                                    helperText={this.getError(form, field.name)}
                                    {...field}
                                />
                            );
                        }}
                    </Field>
                )}
            </div>
        );
    }
}

export const OfferFooterConditionsItem = withStyles(styles)(OfferFooterConditionsItemBase);
